(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-color-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-color-variants')) {
    class ProductColorVariantsScroller extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.product-color-variants__viewport');
        this.previousButton = this.querySelector('[data-color-variants-direction="prev"]');
        this.nextButton = this.querySelector('[data-color-variants-direction="next"]');
        this.handleClick = this.handleClick.bind(this);
        this.updateButtons = this.updateButtons.bind(this);
        this.addEventListener('click', this.handleClick);
        this.viewport.addEventListener('scroll', this.updateButtons, { passive: true });
        this.resizeObserver = new ResizeObserver(this.updateButtons);
        this.resizeObserver.observe(this.viewport);
        this.updateButtons();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.viewport.removeEventListener('scroll', this.updateButtons);
        this.resizeObserver.disconnect();
      }

      getPageDistance() {
        const items = [...this.querySelectorAll('.product-color-variants__item')];
        if (items.length < 2) return this.viewport.clientWidth;
        const itemSpan = items[1].offsetLeft - items[0].offsetLeft;
        const itemGap = itemSpan - items[0].clientWidth;
        const itemsPerPage = Math.max(1, Math.floor((this.viewport.clientWidth + itemGap) / itemSpan));
        return itemsPerPage * itemSpan;
      }

      handleClick(event) {
        const button = event.target.closest('[data-color-variants-direction]');
        if (!button) return;
        const direction = button.dataset.colorVariantsDirection === 'next' ? 1 : -1;
        this.viewport.scrollBy({ left: direction * this.getPageDistance(), behavior: 'smooth' });
      }

      updateButtons() {
        const maximumScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        const currentScroll = Math.abs(this.viewport.scrollLeft);
        const hasOverflow = maximumScroll > 2;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.previousButton.disabled = currentScroll <= 2;
        this.nextButton.disabled = currentScroll >= maximumScroll - 2;
      }
    }

    customElements.define('product-color-variants', ProductColorVariantsScroller);
  }
  } catch(e) { console.error(e); }
})();

})();
